<template>
  <div class="investigation-stepper" ref="stepper">
    <div class="process-section" v-for="(process, idx) in feedbackProcesses" :key="idx">
      <div class="process-header" :class="[
        { 'process-header--with-border': feedbackProcesses.length > 1 && idx < feedbackProcesses.length - 1 },
        { 'done': !!process?.is_completed }
      ]">
        <img class="icon icon--small" :class="[!!process?.is_completed ? 'icon--success' : 'icon--active']"
          :src="getIconSource(!!process?.is_completed)" alt="step-icon">
        <span class="process-title"
          :class="[!!process?.is_completed ? 'process-title--success' : 'process-title--active']">{{ process?.title
          }}</span>
      </div>
      <div class="request-items">
        <template v-for="(subProcess) in process.processes">
          <div :key="subProcess?.id" class="request-card">
            <img class="icon icon--large request-card__icon"
              :class="[subProcess?.status === 'complete' ? 'icon--success' : subProcess?.status === 'on_progress' && subProcess?.status ? 'icon--active' : '']"
              :src="getIconSource(subProcess?.status === 'complete')" alt="step-icon">
            <h6 class="request-card__label">{{ subProcess?.label }}</h6>
            <h5 class="request-card__requester"
              :class="[subProcess?.status === 'complete' ? 'request-card__requester--success' : subProcess?.status === 'on_progress' && subProcess?.status ? 'request-card__requester--active' : '']">
              {{ subProcess?.employee?.role }}</h5>
            <h6 class="request-card__date">{{ subProcess?.date ? moment(subProcess?.date, 'YYYY-MM-DD').format('DD MMM YYYY') : '' }}</h6>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import iconIdle from '@/assets/icons/step.svg'
import iconActive from '@/assets/icons/step-active.svg'
import moment from 'moment'
export default {
  name: "FeedbackSteppers",
  props: ['feedbackProcesses'],
  data() {
    return {
      moment,
    }
  },
  methods: {
    getIconSource(isActive = true) {
      return isActive ? iconActive : iconIdle
    },
    setupDragScroll() {
      const container = this.$refs.stepper
      if (!container) return

      let isDown = false
      let startX = 0
      let scrollLeft = 0

      container.addEventListener('mousedown', (e) => {
        isDown = true
        container.classList.add('dragging')
        startX = e.pageX - container.offsetLeft
        scrollLeft = container.scrollLeft
      })

      container.addEventListener('mouseleave', () => {
        isDown = false
        container.classList.remove('dragging')
      })

      container.addEventListener('mouseup', () => {
        isDown = false
        container.classList.remove('dragging')
      })

      container.addEventListener('mousemove', (e) => {
        if (!isDown) return
        e.preventDefault()
        const x = e.pageX - container.offsetLeft
        const walk = (x - startX) * 1 // control speed
        container.scrollLeft = scrollLeft - walk
      })
    },
  },
  mounted() {
    this.setupDragScroll()
  },
}
</script>

<style lang="css" scoped>
/* Main container */
.investigation-stepper {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  overflow: auto;
  padding-bottom: 0.5rem;
}

.investigation-stepper.dragging {
  cursor: grabbing;
  user-select: none;
  -webkit-user-select: none;
}

.investigation-stepper::-webkit-scrollbar {
  height: 4px;
  border: 1px solid #d5d5d5;
}

.investigation-stepper::-webkit-scrollbar-track {
  border-radius: 0;
  background: #eeeeee;
}

.investigation-stepper::-webkit-scrollbar-thumb {
  border-radius: 0;
  background: #b0b0b0;
}

/* Process section */
.process-section {
  width: auto
}

/* Process header */
.process-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 1rem;
  position: relative;
  width: 100%;
}

.process-header--with-border::after {
  content: '';
  position: absolute;
  top: 50%;
  right: 0;
  width: calc(100% - 200px);
  height: 1px;
  background-color: #2F80ED;
  transform: translateY(-50%);
  z-index: 1;
}

.process-header--with-border.done::after {
  background-color: #219653;
}

.process-title {
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  position: relative;
  z-index: 2;
  background-color: white;
  padding-right: 8px;
}

.process-title--active {
  color: #2F80ED;
}

.process-title--success {
  color: #219653;
}

/* Icons */
.icon {
  display: block;
}

.icon--small {
  width: 16px;
  height: 16px;
}

.icon--large {
  width: 30px;
  height: 30px;
}

.icon--active {
  filter: invert(53%) sepia(59%) saturate(5865%) hue-rotate(200deg) brightness(97%) contrast(91%);
}

.icon--success {
  filter: invert(46%) sepia(16%) saturate(1829%) hue-rotate(93deg) brightness(98%) contrast(91%);
}

/* Request items container */
.request-items {
  display: flex;
  flex-direction: row;
  /* gap: 3rem; */
}

/* Request card */
.request-card {
  display: flex;
  flex-direction: column;
  width: 133px;
}

.request-card__icon {
  margin-bottom: 8px;
}

.request-card__label {
  font-weight: 400;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #C4C4C4;
  margin: 0;
}

.request-card__requester {
  font-family: Roboto;
  font-weight: 600;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  margin: 6px 0 4px;
  color: #A9A9A9;
}

.request-card__requester--active {
  color: #2F80ED;
}

.request-card__requester--success {
  color: #219653;
}

.request-card__date {
  font-weight: 400;
  font-size: 10px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #C4C4C4;
  margin: 0;
}
</style>
